import styled from "styled-components";

export const PlacementsContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  color: #7a89f4;
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 1245px;
  margin: 0 auto;

  gap: 30px;
  height: 93vh;
  padding-top: 20px;
  background-color: rgb(239, 241, 252);
  overflow: hidden;

  @media (min-width: 1440px) and (max-width: 1919px) {
    width: 1480px;
  }

  @media (min-width: 1920px) {
    width: 1745px;
  }

  @media screen and (min-width: 2560px) {
    width: 2045px;
  }

  @media (max-width: 1160px) {
    width: 100%;
  }

  @media (max-width: 780px) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 0;
  }
`;

export const ScrollableContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  height: 100%;
  align-items: flex-start;
  padding-right: 15px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin-block: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #7a89f4;
    border-radius: 4px;
  }
`;

export const FixedColumn = styled.div`
  position: sticky;
  top: 0;
  height: fit-content;
`;

export const PreviewLocked = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
`;
